import { FadeUp } from "@/components/Reveal";

export const OwnerSignIn = ({ denied }) => {
  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/appointments";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="flex min-h-screen items-center bg-ivory pt-32 pb-24" data-testid="owner-signin-page">
      <div className="mx-auto max-w-xl px-6">
        <FadeUp>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-sienna">Private</p>
          <h1 className="mt-5 font-serif text-5xl font-light leading-tight text-espresso lg:text-6xl">
            Your <span className="italic text-sienna">appointments</span>
          </h1>
          <p className="mt-5 text-base leading-relaxed text-cocoa">
            This page holds each mother's private details, so it is kept for Athena alone.
            Sign in with your Google account to open your calendar.
          </p>
          {denied && (
            <p className="mt-6 rounded-xl border border-sienna/40 bg-cream p-4 text-sm text-sienna" data-testid="owner-signin-denied">
              That Google account doesn't have access. Please sign in with Athena's account.
            </p>
          )}
          <button
            onClick={signIn}
            data-testid="owner-signin-google-btn"
            className="mt-10 rounded-full bg-espresso px-8 py-4 text-sm font-medium uppercase tracking-[0.18em] text-ivory transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-sienna"
          >
            Sign in with Google
          </button>
        </FadeUp>
      </div>
    </main>
  );
};
